import React from 'react';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-screen">
      <div className="loading-spinner">
        <div className="loading"></div>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
